import { api_GET, api_POST, api_PUT, api_DELETE } from "./_api.js";

const residuo_api = {
    GetList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Residuo/GetList`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Residuo/GetItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Post: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Residuo`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Put: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`Residuo`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }
}
export default residuo_api;